export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "/rec-rex.worker.22ee2909.js");
}
